import { UserRoles } from '@dynamika-shared/types/auth';
import { getPMQueries, getPMQueryById } from '@api/pmQueryManagement';
import {
  getSponsorQueries,
  getSponsorQueryById,
} from '@api/sponsorQueryManagement';

export type QueriesTransport = {
  list: typeof getPMQueries;
  byId: typeof getPMQueryById;
};

export const QUERIES_TRANSPORT: Partial<Record<UserRoles, QueriesTransport>> = {
  [UserRoles.PROJECT_MANAGER]: {
    list: getPMQueries,
    byId: getPMQueryById,
  },
  [UserRoles.SPONSOR]: {
    list: getSponsorQueries,
    byId: getSponsorQueryById,
  },
};

export const resolveQueriesTransport = (
  role: UserRoles | null
): QueriesTransport | undefined => (role ? QUERIES_TRANSPORT[role] : undefined);
